var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 812,
    height: 48,
    viewBox: "0 0 812 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1789",
    "data-name": "Groupe 1789",
    transform: "translate(15 -205)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_2",
    "data-name": "Ligne 2",
    x2: 763.572,
    transform: "translate(9.5 228.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1610",
    "data-name": "Groupe 1610",
    transform: "translate(-15 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    fill: "#f7c030",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks",
    "data-name": "Bienvenue sur Quicks",
    d: "M11.343,19V7.948H8.733V5.59h5.4V19Z",
    transform: "translate(12 11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1611",
    "data-name": "Groupe 1611",
    transform: "translate(112.117 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-2",
    "data-name": "Rectangle 250",
    fill: "#e0df61",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1612",
    "data-name": "Groupe 1612",
    transform: "translate(239.234 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-3",
    "data-name": "Rectangle 250",
    fill: "#cdd35c",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1613",
    "data-name": "Groupe 1613",
    transform: "translate(366.351 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-4",
    "data-name": "Rectangle 250",
    fill: "#7ab360",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1614",
    "data-name": "Groupe 1614",
    transform: "translate(492.171 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-5",
    "data-name": "Rectangle 250",
    fill: "#4aa35b",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1615",
    "data-name": "Groupe 1615",
    transform: "translate(620.586 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-6",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1616",
    "data-name": "Groupe 1616",
    transform: "translate(749 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-7",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-2",
    "data-name": "Bienvenue sur Quicks",
    d: "M7.392,19V16.84l3.6-3.708q1.062-1.1,1.611-1.737a5.285,5.285,0,0,0,.756-1.071,1.949,1.949,0,0,0,.207-.846,1.472,1.472,0,0,0-.477-1.161,1.738,1.738,0,0,0-1.2-.423,2.163,2.163,0,0,0-1.314.423A2.435,2.435,0,0,0,9.732,9.6L7.3,8.812a3.883,3.883,0,0,1,.9-1.818A4.663,4.663,0,0,1,9.858,5.8a5.044,5.044,0,0,1,2.034-.423,5.5,5.5,0,0,1,2.34.468A3.68,3.68,0,0,1,15.8,7.156a3.513,3.513,0,0,1,.558,1.98,4.106,4.106,0,0,1-.252,1.413,5.811,5.811,0,0,1-.765,1.4,13.778,13.778,0,0,1-1.323,1.539L10.938,16.66h5.544V19Z",
    transform: "translate(124 216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-3",
    "data-name": "Bienvenue sur Quicks",
    d: "M11.748,19.216a5.434,5.434,0,0,1-2.124-.423,4.762,4.762,0,0,1-1.71-1.2,3.941,3.941,0,0,1-.936-1.818l2.466-.828a2.684,2.684,0,0,0,.9,1.3,2.29,2.29,0,0,0,1.4.441,2.417,2.417,0,0,0,1.143-.252,1.854,1.854,0,0,0,.747-.711,2.073,2.073,0,0,0,.27-1.071,2.031,2.031,0,0,0-.261-1.053,1.77,1.77,0,0,0-.738-.684,2.535,2.535,0,0,0-1.161-.243,3.564,3.564,0,0,0-.792.09,3.18,3.18,0,0,0-.72.252l-.648-1.35L13.026,7.93H7.788V5.59h8.37V7.75L12.63,11.764l.09-1.134a4.25,4.25,0,0,1,2.1.495A3.516,3.516,0,0,1,16.2,12.5a4.123,4.123,0,0,1,.495,2.052,4.5,4.5,0,0,1-.648,2.394,4.573,4.573,0,0,1-1.764,1.665A5.253,5.253,0,0,1,11.748,19.216Z",
    transform: "translate(251 216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-4",
    "data-name": "Bienvenue sur Quicks",
    d: "M12.558,19V16.12H6.618V13.78l5.76-8.19h2.97v8.19h2.07v2.34h-2.07V19ZM8.652,14.788,8.13,13.78h4.428V7.75l.7.216Z",
    transform: "translate(378 216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-5",
    "data-name": "Bienvenue sur Quicks",
    d: "M11.784,19.216a5.37,5.37,0,0,1-2.052-.4A4.765,4.765,0,0,1,8.04,17.659a3.636,3.636,0,0,1-.918-1.791l2.466-.828a2.252,2.252,0,0,0,.864,1.26,2.348,2.348,0,0,0,1.332.4,2.218,2.218,0,0,0,1.1-.261,1.836,1.836,0,0,0,.729-.738,2.27,2.27,0,0,0,.261-1.107,2.218,2.218,0,0,0-.261-1.1,1.852,1.852,0,0,0-.729-.729,2.218,2.218,0,0,0-1.1-.261,2.339,2.339,0,0,0-1.152.279,1.65,1.65,0,0,0-.738.855L7.608,13.1,8.688,5.59h7.488V7.93H9.822l1.044-1.26-.738,5.58-.756-.666a2.774,2.774,0,0,1,1.143-1.08,4.054,4.054,0,0,1,1.791-.342,4.53,4.53,0,0,1,2.322.567,3.908,3.908,0,0,1,1.5,1.557,4.8,4.8,0,0,1,.531,2.3,4.472,4.472,0,0,1-.639,2.367,4.563,4.563,0,0,1-1.737,1.656A5.112,5.112,0,0,1,11.784,19.216Z",
    transform: "translate(504 216)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.d4945b54aff25739fd1b928a40daa07d.svg";
export { ForwardRef as ReactComponent };